import { Component, Input } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { ComponentState, ComponentStateService } from 'app/core/services';
import { map, Observable, startWith } from 'rxjs';

export interface PageHeaderState {
  isCollapsed: boolean;
}

@Component({
  selector: 'insol-page-header',
  animations: fuseAnimations,
  template: `<mat-icon
      class="absolute -z--1 print:hidden"
      (click)="toggleCollapse()"
      [svgIcon]="(isCollapsed$ | async) ? 'heroicons_outline:chevron-down' : 'heroicons_outline:chevron-up'"></mat-icon>

    <div
      *ngIf="(isCollapsed$ | async) === false"
      @expandCollapse
      class="relative inset-0 flex flex-row min-w-0 overflow-x-auto bg-card dark:bg-transparent print:hidden">
      <!-- <div class="relative flex flex-col flex-0 py-8 px-6 md:px-8 {{ noborder ? '' : 'border-b' }}"> -->
      <div class="relative flex flex-col py-8 px-6 md:px-8 {{ noborder ? '' : 'border-b' }}">
        <div class="text-4xl font-extrabold tracking-tight">{{ title }}</div>
        <div class="flex align-middle">
          <mat-icon svgIcon="{{ subicon }}"></mat-icon><span class="ml-2">{{ subtitle }}</span>
        </div>
      </div>
    </div>`,
})
export class PageHeaderComponent {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() subicon: string;
  @Input() noborder: boolean;

  isCollapsed$: Observable<boolean>;

  private pageHeaderState: ComponentState<PageHeaderState>;

  constructor(componentStateService: ComponentStateService) {
    this.pageHeaderState = componentStateService.getComponentState<PageHeaderState>('PageHeader', 'global', {
      isCollapsed: false,
    });

    this.isCollapsed$ = this.pageHeaderState.stateChanged$.pipe(
      startWith(this.pageHeaderState.getState()),
      map((state) => state.isCollapsed)
    );
  }

  toggleCollapse(): void {
    this.pageHeaderState.setState({ isCollapsed: !this.pageHeaderState.getState().isCollapsed });
  }
}
